module.exports = __webpack_public_path__ + "img/tips.ed58796.png";